// Similar to native modulo operator a % b
// But this helper also handles negative numbers like mod(-1, 4) === 3
// @ref https://stackoverflow.com/a/4467559/1042324
// @ref https://www.geeksforgeeks.org/how-to-get-negative-result-using-modulo-operator-in-javascript
export const mod = (a: number, b: number) => {
  return ((a % b) + b) % b
}

/**
 * Checks if a string is a valid roman numeral
 * @param str The string to check, case insensitive
 * @example
 * isRomanNumeral('MCMXCIV') // true
 */
export const isRomanNumeral = (str: string): boolean => {
  if (str.length === 0) return false
  const regex = /^(M{0,3})(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/i
  return regex.test(str)
}

/**
 * Utility function to convert a single roman numeral character to its numeric value
 * @param char The roman numeral character (case insensitive)
 * @returns The numeric value of the roman numeral character
 */
const charToValue = (char: string): number => {
  char = char.toUpperCase()
  switch (char) {
    case 'I':
      return 1
    case 'V':
      return 5
    case 'X':
      return 10
    case 'L':
      return 50
    case 'C':
      return 100
    case 'D':
      return 500
    case 'M':
      return 1000
    default:
      return 0
  }
}

/**
 * Converts a roman numeral to a number
 * @param str The roman numeral to convert to a number (case insensitive)
 * @returns The number or null if the string is not a valid roman numeral
 * @example
 * romanToDecimal('MCMXCIV') // 1994
 */
export const romanToDecimal = (str: string): number | null => {
  if (!isRomanNumeral(str)) {
    return null
  }

  let result = 0
  let prevValue = 0

  for (const char of str.split('').reverse()) {
    const currentValue = charToValue(char)

    if (currentValue < prevValue) {
      result -= currentValue
    } else {
      result += currentValue
    }
    prevValue = currentValue
  }

  return result
}
